module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl2-50.c8462dda.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl2-50.png
// module id = 3500
// module chunks = 11